import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { formatNisAmount } from '../../utils/labData';

/**
 * Spend breakdown by supplier. A row with a supplier id opens the orders list
 * for the same date range.
 *
 * @param {Object} props
 * @param {Array} [props.suppliers]
 * @param {string} [props.dateFrom]
 * @param {string} [props.dateTo]
 */
const SpendBySupplierTable = ({ suppliers = [], dateFrom, dateTo }) => {
  const navigate = useNavigate();

  const handleRowClick = row => {
    if (!row?.supplier_id) return;
    const params = new URLSearchParams();
    if (dateFrom) params.set('from', dateFrom);
    if (dateTo) params.set('to', dateTo);
    params.set('supplier_id', String(row.supplier_id));
    navigate(`/orders?${params.toString()}`);
  };

  return (
    <div className="glass-panel lab-data-table-card">
      <h3 className="lab-data-section-title">Spend by supplier</h3>
      {!suppliers?.length ? (
        <div className="glass-empty">No supplier spend in this period.</div>
      ) : (
        <div className="glass-table-wrap">
          <Table hover size="sm" className="mb-0">
            <thead>
              <tr>
                <th>Supplier</th>
                <th className="text-end">Spend</th>
                <th className="text-end">Orders</th>
                <th className="text-end">Lines</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.map(row => (
                <tr
                  key={row.supplier_id ?? row.supplier_name}
                  className={row.supplier_id ? 'lab-data-row-clickable' : ''}
                  onClick={() => handleRowClick(row)}
                >
                  <td>{row.supplier_name ?? row.name ?? '—'}</td>
                  <td className="text-end">
                    {formatNisAmount(row.total_nis ?? row.spend_nis)}
                  </td>
                  <td className="text-end">{row.order_count ?? '—'}</td>
                  <td className="text-end">{row.line_count ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default SpendBySupplierTable;
